// extracted by mini-css-extract-plugin
export default {"checkbox":"TariffForm_checkbox__2Z32X","grid2Cols":"TariffForm_grid2Cols__7h6Xo"};